<template>
  <v-card>
    <v-card-title>
      Categorías
      <v-spacer />
      <v-btn color="primary" @click="openCreateDialog">
        Nueva categoría
      </v-btn>
    </v-card-title>

    <v-simple-table>
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-left">Código</th>
            <th class="text-left">Descripción</th>
            <th class="text-left">Activa</th>
            <th class="text-left">Acciones</th>
          </tr>
        </thead>
        <draggable
          v-model="sortedCategories"
          tag="tbody"
          handle=".drag-handle"
          @end="handleReorder"
        >
          <tr
            v-for="item in sortedCategories"
            :key="item._id"
            class="draggable-row"
          >
            <!-- Drag handle -->
            <td>
              <div class="d-flex align-center">
                <v-icon small class="drag-handle mr-2">mdi-drag</v-icon>
                <div
                  :style="{
                    backgroundColor: item.color,
                    width: '20px',
                    height: '20px',
                    borderRadius: '4px'
                  }"
                  class="mr-2"
                />
                <span>{{ item.code }}</span>
              </div>
            </td>

            <!-- Descripción -->
            <td>{{ item.description }}</td>

            <!-- Activo -->
            <td>
              <v-chip :color="item.active ? 'green' : 'grey'" dark small>
                {{ item.active ? "Sí" : "No" }}
              </v-chip>
            </td>

            <!-- Acciones -->
            <td>
              <v-icon
                small
                color="primary"
                class="mr-2"
                @click="openEditDialog(item)"
              >
                mdi-pencil
              </v-icon>
              <v-icon small color="error" @click="confirmDelete(item)">
                mdi-delete
              </v-icon>
            </td>
          </tr>
        </draggable>
      </template>
    </v-simple-table>

    <!-- DIALOG FORM -->
    <v-dialog v-model="dialog" max-width="500px">
      <v-card>
        <v-card-title>
          {{ editedItem ? "Editar" : "Crear" }} categoría
        </v-card-title>
        <v-card-text>
          <FormLeadCategory
            :category="editedItem"
            @save="saveCategory"
            @cancel="closeDialog"
          />
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";

export default {
  name: "CategoriesTable",
  components: {
    FormLeadCategory: () => import("./Form.vue"),
    draggable: () => import("vuedraggable")
  },

  data() {
    return {
      dialog: false,
      editedItem: {
        _id: null,
        code: "",
        description: "",
        color: "",
        active: true,
        order: 0
      },
      headers: [
        //{ text: "Color", value: "color" },
        { text: "Código", value: "code" },
        { text: "Descripción", value: "description" },
        { text: "Activa", value: "active" },
        { text: "Acciones", value: "actions", sortable: false }
      ],
      realEstateGroupId: localStorage.getItem("ag")
    };
  },
  async created() {
    await this.getCategories(this.realEstateGroupId);
  },
  computed: {
    ...mapState("realEstateGroup", {
      categories: state => state.categoryLeads.categories
    }),
    sortedCategories: {
      get() {
        return [...this.categories].sort((a, b) => {
          const orderA = a.order || 0;
          const orderB = b.order || 0;
          return orderA - orderB;
        });
      },
      set(value) {
        const categories = Array.from(value).map((cat, index) => ({
          ...cat,
          order: index + 1
        }));
        this.SET_CATEGORIES(categories);
      }
    }
  },
  methods: {
    ...mapActions("realEstateGroup", {
      getCategories: "categoryLeads/getCategories",
      createCategory: "categoryLeads/createCategory",
      updateCategory: "categoryLeads/updateCategory",
      deleteCategory: "categoryLeads/deleteCategory",
      reorderCategories: "categoryLeads/reorderCategories"
    }),
    ...mapMutations("realEstateGroup", {
      SET_CATEGORIES: "categoryLeads/SET_CATEGORIES"
    }),
    openCreateDialog() {
      this.editedItem = {};
      this.dialog = true;
    },

    openEditDialog(item) {
      this.editedItem = { ...item };
      this.dialog = true;
    },

    closeDialog() {
      this.dialog = false;
    },

    async saveCategory(payload) {
      try {
        const data = {
          ...payload,
          real_estate_group_id: this.realEstateGroupId
        };
        if (payload?._id) {
          await this.updateCategory(data);
        } else {
          await this.createCategory(data);
        }
        this.$snotify.success("Categoría guardada correctamente", "Guardado");
      } catch (error) {
        this.$snotify.error("Error al guardar la categoría", "Error");
      } finally {
        this.editedItem = undefined;
        this.dialog = false;
      }
    },

    async confirmDelete(item) {
      this.$confirmation(
        "Eliminar",
        "¿Estas seguro que deseas eliminar esta categoría?",
        () => this.handleDelete(item)
      );
    },
    async handleDelete(item) {
      try {
        await this.deleteCategory({
          id: item._id,
          groupId: this.realEstateGroupId
        });
        this.$snotify.success("Categoría eliminada correctamente", "Eliminado");
      } catch (error) {
        this.$snotify.error("Error al eliminar la categoría", "Error");
      }
    },

    async handleReorder() {
      try {
        const items = this.sortedCategories.map(cat => ({
          id: cat._id,
          order: cat.order
        }));
        await this.reorderCategories({
          groupId: this.realEstateGroupId,
          items
        });

        this.$snotify.success("Orden actualizado correctamente", "Guardado");
      } catch (error) {
        this.$snotify.error("Error al actualizar el orden", "Error");
        await this.getCategories(this.realEstateGroupId);
      }
    }
  }
};
</script>

<style scoped>
.drag-handle {
  cursor: move;
  cursor: grab;
}

.drag-handle:active {
  cursor: grabbing;
}

.draggable-row {
  transition: background-color 0.2s;
}

.draggable-row:hover {
  background-color: rgba(0, 0, 0, 0.02);
}
</style>
